<template>
  <div class="mb-memory" @click="cancelCheck()">
    <img
      v-if="startGameConfig.mainImage"
      class="main-img"
      draggable="false"
      @click="cancelCheck()"
      :src="giveMeImagePlease(startGameConfig.mainImage.imagePath)"
      :style="{
        width: startGameConfig.mainImage.width + 'px' || 1920 + 'px',
        height: startGameConfig.mainImage.height + 'px' || 1080 + 'px',
        top: startGameConfig.mainImage.pos.y + 'px' || 0 + 'px',
        left: startGameConfig.mainImage.pos.y + 'px' || 0 + 'px',
      }"
    />
    <div
      class="memory-box"
      :style="{
        width: startGameConfig.columns * (startGameConfig.width + 20) + 'px' || 200 + 'px',
      }"
      v-if="startGameConfig.type != 'findImage'"
    >
      <div
        :key="'mb-memory-field' + index"
        class="mb-memory-field"
        v-for="(fieldToSelect, index) in items"
        :style="{
          width: startGameConfig.width + 'px' || 200 + 'px',
          height: startGameConfig.height + 'px' || 200 + 'px',
          background: startGameConfig.bcg ? startGameConfig.bcg : 'transparent',
          backgroundImage: startGameConfig.bcgImg ? 'url(' + giveMeImagePlease(startGameConfig.bcgImg) + ')' : '',
          backgroundSize: 'cover',
        }"
      >
        <transition name="memory-fade">
          <div
            v-if="fieldToSelect.correct"
            class="correct-field"
            :style="
              fieldToSelect.correct
                ? { border: '5px solid ' + fieldToSelect.imageHighlightColor, borderRadius: '7px' }
                : {}
            "
          ></div>
        </transition>
        <div class="mb-memory-field-box">
          <img
            v-if="fieldToSelect.image && isLoaded"
            class="mb-memory-field-img"
            draggable="false"
            :style="[fieldToSelect.cssStyle]"
            :src="giveMeImagePlease(fieldToSelect.image.src)"
          />
          <p
            v-if="fieldToSelect.text && isLoaded"
            class="mb-memory-field-text"
            :style="fieldToSelect.cssStyle"
            v-html="fieldToSelect.text"
          ></p>
        </div>
        <transition name="memory-fade">
          <div
            class="memory-curtain"
            v-if="curtain[index].show"
            @click="changeCurtain(index)"
            :style="{
              width: startGameConfig.width + 'px' || 200 + 'px',
              height: startGameConfig.height + 'px' || 200 + 'px',
              background: startGameConfig.curtain || 'black',
            }"
          >
            <img
              v-if="curtainImg"
              draggable="false"
              @load="onImgLoad"
              :src="giveMeImagePlease(curtainImg.src)"
              style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
            />
          </div>
        </transition>
      </div>
    </div>
    <div
      v-if="startGameConfig.type == 'findImage'"
      style="position: absolute"
      :style="{
        width: startGameConfig.imageToFind.width + 'px',
        height: startGameConfig.imageToFind.height + 'px',
        top: startGameConfig.imageToFind.pos.y + 'px',
        left: startGameConfig.imageToFind.pos.x + 'px',
      }"
    >
      <img
        :src="giveMeImagePlease(startGameConfig.imageToFind.src)"
        draggable="false"
        style="position: absolute; top: 0; width: 100%; height: 100%; left: 0"
      />
      <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%">
        <div
          :style="{
            position: 'absolute',
            cursor: 'pointer',
            top: field.top,
            left: field.left,
            width: field.width,
            height: field.height,
          }"
          :key="'curtain-img-' + indexImg"
          v-for="(field, indexImg) in fieldImg"
        >
          <transition name="memory-fade">
            <img
              :src="giveMeImagePlease(field.src)"
              style="width: 100%; height: 100%"
              v-if="field.index >= currentField"
              @click="checkField(field.index)"
            />
          </transition>
        </div>
      </div>
    </div>
    <mb-audio-in-game
      :key="data.top + data.left + 'audio' + index"
      v-for="(data, index) in startGameConfig.mbAudioItemData"
      :item-data="data"
    ></mb-audio-in-game>
  </div>
</template>
<script>
import { Howler } from 'howler';
import defaultMixin from '../../mixins/defaultMixin';
import mbAudioInGame from '__mainSrcDir/components/MbAudioModal/MbAudioInGame';
export default {
  name: 'mb-memory',
  components: { mbAudioInGame },
  mixins: [defaultMixin],
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
    assets: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      isLoaded: false,
      curtainImg: null,
      currentImg: -1,
      audio: null,
      status: false,
      canIPlay: true,
      items: [],
      curtain: [],
      openItem: [],
      fieldImg: [],
      currentField: 0,
      canICheck: true,
      audioClick: null,
      audioNegative: null,
      audioPositive: null,
      canIPlayASong: true,
      canIClick: true,
    };
  },
  created() {},
  beforeMount() {
    if (this.startGameConfig.type != 'findImage') {
      this.init();
    } else {
      this.findImgInit();
    }
    if (this.startGameConfig.goodAudio) {
      this.setAudioConfig(this.startGameConfig.goodAudio, 1);
    }
  },
  mounted() {},
  methods: {
    onImgLoad() {
      this.isLoaded = true;
    },
    cancelCheck() {
      this.$store.commit('CHANGE_CHECK_SWITCH', false);
    },
    checkSound(status) {
      if (status) {
        if (this.audioPositive) {
          if (this.canIPlayASong) {
            this.audioPositive.play();
          } else {
            this.audioPositive.stop();
            if (this.audioNegative) {
              this.audioNegative.stop();
            }
            this.audioPositive.play();
          }
        }
      } else {
        if (this.audioNegative) {
          if (this.canIPlayASong) {
            this.audioNegative.play();
          } else {
            this.audioNegative.stop();
            if (this.audioPositive) {
              this.audioPositive.stop();
            }
            this.audioNegative.play();
          }
        }
      }
    },
    checkField(index) {
      if (this.canICheck) {
        this.canICheck = false;
        console.log(index);
        console.log(this.currentField);
        if (this.currentField == index) {
          this.currentField++;
          if (this.gameActive) this.checkSound(true);
        } else {
          this.currentField = 0;
          if (this.gameActive) this.checkSound(false);
        }
        if (this.fieldImg.length == this.currentField) {
          this.$store.dispatch('checkGame');
        } else {
          setTimeout(() => {
            this.canICheck = true;
          }, 500);
        }
      }
    },
    checkGameAction() {
      if (this.startGameConfig.type != 'findImage') {
        if (this.curtain.every((x) => x.show == false)) {
          return true;
        } else return false;
      } else {
        if (this.fieldImg.length == this.currentField) {
          return true;
        } else return false;
      }
    },
    checkIndex() {
      if (this.items[this.openItem[0]].id == this.items[this.openItem[1]].id) {
        let it1 = this.items[this.openItem[1]];
        it1.correct = true;
        let it0 = this.items[this.openItem[0]];
        it0.correct = true;
        this.items.splice(this.openItem[1], 1, it1);
        this.items.splice(this.openItem[0], 1, it0);
        console.log('GOOOOOOD');
        this.checkSound(true);
        this.openItem = [];
        if (this.audio) {
          this.startAudio();
        }
        if (this.gameActive) {
          this.checkAllItems();
        }
      } else {
        this.checkSound(false);
        console.log('BADDDDDD');
        setTimeout(() => {
          this.curtain[this.openItem[0]].show = true;
          this.curtain[this.openItem[1]].show = true;
          this.openItem = [];
        }, 1200);
      }
    },
    checkAllItems() {
      if (this.curtain.every((x) => x.show == false)) {
        console.log('yeah!');
        this.$store.dispatch('checkGame');
      }
    },
    changeCurtain(index) {
      let time = 800;
      let audioTime = 300;
      if (this.canIClick) {
        if (this.audioClick) {
          this.audioClick.play();
        }
        if (this.items[index].audio) {
          this.playFieldAudio(this.items[index].audio);
          audioTime = this.items[index].audio.duration() * 1000;
        }
        this.canIClick = false;
        if (this.openItem.length < 2) {
          if (this.openItem.length == 1 && !this.openItem[0] != index) {
            this.curtain[index].show = false;
            this.openItem.push(index);
          } else {
            this.curtain[index].show = false;
            this.openItem.push(index);
          }
          if (this.openItem.length == 2) {
            time = 1200 + audioTime;
            setTimeout(() => {
              if (this.gameActive) {
                this.checkIndex();
              }
            }, audioTime);
          }
        }
        setTimeout(() => {
          this.canIClick = true;
        }, time);
      }
    },
    findImgInit() {
      let item = this.startGameConfig.curtainImages;
      if (this.startGameConfig.audio) {
        if (this.startGameConfig.audio.positive) {
          this.audioPositive = new Howl({
            src: this.giveMeImagePlease(this.startGameConfig.audio.positive),
            autoplay: false,
            loop: false,
            volume: 0.5,
            onend: () => {
              this.canIPlayASong = true;
            },
            onstop: () => {
              this.canIPlayASong = true;
            },
            onplay: () => {
              this.canIPlayASong = false;
            },
          });
        }
        if (this.startGameConfig.audio.click) {
          this.audioClick = new Howl({
            src: this.giveMeImagePlease(this.startGameConfig.audio.click),
            autoplay: false,
            loop: false,
            volume: 0.5,
          });
        }
        if (this.startGameConfig.audio.negative) {
          this.audioNegative = new Howl({
            src: this.giveMeImagePlease(this.startGameConfig.audio.negative),
            autoplay: false,
            loop: false,
            volume: 0.5,
            onend: () => {
              this.canIPlayASong = true;
            },
            onstop: () => {
              this.canIPlayASong = true;
            },
            onplay: () => {
              this.canIPlayASong = false;
            },
          });
        }
      }
      this.shuffle(item);
      let y = 0;
      let x = 0;
      for (let i = 0; i < item.length; i++) {
        this.fieldImg.push({
          width: 100 / this.startGameConfig.columns + '%',
          height: 100 / this.startGameConfig.rows + '%',
          top: (100 / this.startGameConfig.rows) * y + '%',
          left: (100 / this.startGameConfig.columns) * x + '%',
          src: item[i].src,
          index: item[i].index,
        });
        y++;
        if (y == this.startGameConfig.columns) {
          x++;
          y = 0;
        }
      }
      console.log(this.findImg);
    },
    playFieldAudio(audio) {
      if (audio) {
        audio.play();
      }
    },
    init() {
      let ind = [];
      let borderColors = this.startGameConfig.colors;
      this.shuffle(borderColors);
      this.items = [];
      this.items = this.startGameConfig.fields;
      if (Array.isArray(this.startGameConfig.curtainImage)) {
        let tmpBacks = this.shuffle(this.startGameConfig.curtainImage);
        this.curtainImg = tmpBacks[0];
      } else {
        this.curtainImg = this.startGameConfig.curtainImage;
      }
      if (this.startGameConfig.pick) {
        let tmpItm = [];
        this.shuffle(this.items);
        tmpItm = this.items.slice(0, this.startGameConfig.pick);
        this.items = [];
        tmpItm.forEach((el, idx) => {
          this.items.push(el);
          this.items.push(el.pair);
          if (borderColors.length < idx + 1) {
            ind[el.id] = borderColors.slice(-1);
          } else {
            ind[el.id] = borderColors[idx];
          }
        });
      }
      this.shuffle(this.items);
      this.items.forEach((el) => {
        el.imageHighlightColor = ind[el.id];
        el.correct = false;
        if (el.audioSrc) {
          el.audio = new Howl({
            src: this.giveMeImagePlease(el.audioSrc),
            autoplay: false,
            loop: false,
            volume: 0.6,
            onend: () => {
              this.canIPlayASong = true;
            },
            onstop: () => {
              this.canIPlayASong = true;
            },
            onplay: () => {
              this.canIPlayASong = false;
            },
          });
        }
        this.curtain.push({ show: true });
      });
      if (this.startGameConfig.audio) {
        if (this.startGameConfig.audio.positive) {
          this.audioPositive = new Howl({
            src: this.giveMeImagePlease(this.startGameConfig.audio.positive),
            autoplay: false,
            loop: false,
            volume: 0.5,
            onend: () => {
              this.canIPlayASong = true;
            },
            onstop: () => {
              this.canIPlayASong = true;
            },
            onplay: () => {
              this.canIPlayASong = false;
            },
          });
        }
        if (this.startGameConfig.audio.click) {
          this.audioClick = new Howl({
            src: this.giveMeImagePlease(this.startGameConfig.audio.click),
            autoplay: false,
            loop: false,
            volume: 0.5,
          });
        }
        if (this.startGameConfig.audio.negative) {
          this.audioNegative = new Howl({
            src: this.giveMeImagePlease(this.startGameConfig.audio.negative),
            autoplay: false,
            loop: false,
            volume: 0.5,
            onend: () => {
              this.canIPlayASong = true;
            },
            onstop: () => {
              this.canIPlayASong = true;
            },
            onplay: () => {
              this.canIPlayASong = false;
            },
          });
        }
      }
    },
    imageSetStyle(currentImg, index, imgToSelect) {
      console.log(imgToSelect);
      return currentImg == index && this.startGameConfig.imageHighlight != false
        ? {
            filter: 'drop-shadow(0 0 40px ' + imgToSelect.imageHighlightColor + ')',
          }
        : {};
    },
    setAudioConfig(src, volume) {
      this.audio = new Howl({
        src: this.giveMeImagePlease(src),
        autoplay: false,
        loop: false,
        volume: volume || 1,
        onend: () => {
          this.canIPlayASong = true;
          this.$store.commit('STATE_AUDIO', false);
        },
        onstop: () => {
          this.canIPlayASong = true;
          this.$store.commit('STATE_AUDIO', false);
        },
        onplay: () => {
          this.canIPlayASong = false;
        },
      });
    },
    startAudio() {
      this.audio.play();
    },
    stopAudio() {
      this.audio.stop();
    },
    setImg(index, audio) {
      if (this.canIPlay) {
        if (this.currentImg != -1 && this.audio != null) {
          this.stopAudio();
        }
        if (audio) {
          this.setAudioConfig(audio.src, audio.volume);
        }
        this.currentImg = index;
        this.canIPlay = false;
        setTimeout(() => {
          this.canIPlay = true;
        }, 500);
      }
    },
    giveMeImagePlease(path) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
    },
    resetGameAction() {
      this.audio = null;
      this.status = false;
      this.canIPlay = true;
      this.items = [];
      this.curtain = [];
      this.openItem = [];
      if (this.startGameConfig.type != 'findImage') {
        this.init();
      } else {
        this.fieldImg = [];
        this.currentField = 0;
        this.findImgInit();
        this.canICheck = true;
      }
    },
    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    toBase64(index) {
      let elem = this.$refs['signaturePad-' + index];
      return elem[0].saveSignature().data;
      //console.log(elem[0].saveSignature().data);
    },
  },
  destroyed() {
    if (this.currentImg != -1) {
      this.stopAudio();
    }
  },
  computed: {
    backgroundImageUrl() {
      return 'static/' + this.startGameConfig.background;
    },
    gameActive() {
      return this.$store.getters.gameActive;
    },
  },
};
</script>
<style lang="sass" scoped>
// @import '~pretty-checkbox/src/pretty-checkbox.scss';
@import '~@/assets/sass/variable'
@import '~@/assets/sass/iconColor'
$backgroundWidth: 1906px
$backgroundHeight: 900px
$backgroundOffsetTop: 140px
$backgroundOffsetLeft: 0
.main-img
  position: fixed
  object-fit: cover
.mb-memory,
  background-size: contain
  background-repeat: no-repeat
  position: absolute
  top: $backgroundOffsetTop
  left: $backgroundOffsetLeft
  height: $backgroundHeight
  width: 1920px
  // top: 50px
  display: flex
  justify-content: center
  align-items: center
  // flex-basis: 30%
  flex-wrap: wrap
  .memory-box
    .mb-memory-field
      display: inline-block
      margin: 5px 10px
      cursor: pointer
      position: relative
      filter: drop-shadow(7px 7px rgba(0,0,0, .2))
      .correct-field
        position: absolute
        width: 100%
        height: 100%
      .mb-memory-field-box
        position: absolute
        text-align: center
        transform:
        width: 100%
        height: 100%
        display: flex
        align-items: center
        justify-content: center
      .mb-memory-field-img, .mb-memory-field-text
        // display: flex
        // justify-content: center
        // align-items: center
        max-width: 100%
        max-height: 100%
        user-select: none
        margin: 0
      .memory-curtain
        position: absolute
        top: 0
        user-select: none

.memory-fade-leave-active, .memory-fade-enter-active
  transition: all .3s linear
.memory-fade-leave-to, .memory-fade-enter
  opacity: 0
</style>
